// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tSLz","toggleWrap":"styles_toggleWrap__1BDaV","content":"styles_content__3qEUk","selectAreaCode":"styles_selectAreaCode__2rBBm"};